import App from './upload_history/UploadHistory.svelte';

const app = new App({
	target: document.getElementById("page_body"),
	props: {}
});

export default app;
